import * as $ from 'jquery';

class SavedPropertiesManager {
	private static instance: SavedPropertiesManager;
	private static cookieName: string = 'savedPropertiesKey';

	private static savedPropertyToggleSelector: string = '.item__favorite';
	private static savedPropertyToggleClickSelector: string = SavedPropertiesManager.savedPropertyToggleSelector
		+ ', ' + SavedPropertiesManager.savedPropertyToggleSelector + ' svg'
		+ ', ' + SavedPropertiesManager.savedPropertyToggleSelector + ' svg path'
		+ ', ' + SavedPropertiesManager.savedPropertyToggleSelector + ' svg use';

	public constructor() {
		if (SavedPropertiesManager.instance) {
			return SavedPropertiesManager.instance;
		}
		SavedPropertiesManager.instance = this;
	}

	init() {
		if (!document.querySelector('.enableSavedPropertiesManager')) {
			return;
		}

		window.addEventListener('storage', e => {
			if (e.key === SavedPropertiesManager.cookieName) {
				this.onSavedPropertiesChange();
			}
		});

		$(document).on('submit', event => {
			(document.querySelector('.savedPropertiesInput') as HTMLInputElement).value = this.getSavedPropertiesRaw();
		});

		this.onReady = this.onReady.bind(this);
		if (document.readyState === "interactive" || document.readyState === "complete") {
			this.onReady();
		} else {
			document.addEventListener("DOMContentLoaded", this.onReady);
		}
	}

	private onReady() {
		if (!!(window as any).savedPropertiesReplacement) { //If the backend has provided a replacement for the current saved properties, use it.
			const savedPropertiesReplacement: string[] = (window as any).savedPropertiesReplacement;
			this.setSavedProperties(savedPropertiesReplacement);
			(window as any).savedPropertiesReplacement = null;
		} else { //Otherwise, load the saved properties from local storage
			this.onSavedPropertiesChange();
		}

		$(document).on('click', SavedPropertiesManager.savedPropertyToggleClickSelector, event => {
			let target: HTMLElement = event.target;
			if (target.nodeName === 'path') {
				target = target.parentElement ?? (target.parentNode as HTMLElement); // I hate IE 11
			}
			if (target.nodeName === 'use') {
				target = target.parentElement ?? (target.parentNode as HTMLElement); // I hate IE 11
			}
			if (target.nodeName === 'svg') {
				target = target.parentElement ?? (target.parentNode as HTMLElement); // I hate IE 11
			}
			const propertyId: string = $(target).parents('.propertyHolder').data('property-id');
			if (target.classList.contains('isFavorite')) {
				if (this.removeSavedProperty(propertyId)) {
					target.classList.remove('isFavorite');
				}
			} else {
				if (this.addSavedProperty(propertyId)) {
					target.classList.add('isFavorite');
				}
			}
			event.stopPropagation();
		});

		document.addEventListener('jsfAjaxEvent', event => {
			if ((event as any).detail.fireType === 'always') {
				this.onSavedPropertiesChange();
			}
		});

		const colorboxDefaults: ColorboxSettings = {
			transition: 'fade',
			href: function() {
				return $(this).attr('href') + ' ' + this.getAttribute('data-fragment');
			},
			fixed: true,
			opacity: .9,
			scalePhotos: true,
			maxWidth: '90%',
			maxHeight: '90%',
			initialWidth: 500,
			initialHeight: 300,
			scrolling: false,
			next: '',
			previous: '',
			rel: 'colorbox',
			close: '<span>Close</span>',
			onComplete: () => {
				(document.querySelector('.savedPropertiesEmailSenderForm .savedPropertiesInput') as HTMLInputElement).value = this.getSavedPropertiesRaw();
			}
		};

		const setUpColorbox = () => {
			const elements = $('.savePropertiesLightboxOpener:not(.already-set-up)');
			elements.each((idx, ele) => ele.classList.add('already-set-up'));
			elements.colorbox(colorboxDefaults);
		};
		setUpColorbox();
		document.addEventListener('jsfAjaxEvent', setUpColorbox);
	}

	public getSavedPropertiesRaw(): string {
		const savedPropertiesString = window.localStorage.getItem(SavedPropertiesManager.cookieName);
		return !savedPropertiesString ? '' : savedPropertiesString;
	}
	public getSavedProperties(): string[] {
		const savedPropertiesString = window.localStorage.getItem(SavedPropertiesManager.cookieName);
		return !savedPropertiesString ? [] : savedPropertiesString.split(',');
	}
	public setSavedProperties(savedProperties: string[]) {
		if (!savedProperties || savedProperties.length === 0) {
			window.localStorage.removeItem(SavedPropertiesManager.cookieName);
		} else {
			window.localStorage.setItem(SavedPropertiesManager.cookieName, savedProperties.join(','));
		}
		this.onSavedPropertiesChange();
	}

	public addSavedProperty(propertyId: string): boolean {
		const savedProperties = this.getSavedProperties();
		if (savedProperties.indexOf(propertyId) <= -1) {
			savedProperties.push(propertyId);
			this.setSavedProperties(savedProperties);
			return true;
		}
		return false;
	}

	public removeSavedProperty(propertyId: string): boolean {
		const savedProperties = this.getSavedProperties();
		const index = savedProperties.indexOf(propertyId);
		if (index > -1) {
			savedProperties.splice(index, 1);
			this.setSavedProperties(savedProperties);
			return true;
		}
		return false;
	}
	public toggleSavedProperty(propertyId: string) {
		if (!this.addSavedProperty(propertyId)) {
			this.removeSavedProperty(propertyId);
		}
	}

	public onSavedPropertiesChange() {
		const savedProperties = this.getSavedProperties();

		const propertyHolders = document.querySelectorAll(".propertyHolder");
		for (let i = 0; i < propertyHolders.length; i++) {
			const propertyHolder = propertyHolders[i] as HTMLElement | SVGElement;
			const propertyId: string = propertyHolder.dataset.propertyId;
			const favoritesMarker = propertyHolder.querySelector(SavedPropertiesManager.savedPropertyToggleSelector);
			if (savedProperties.indexOf(propertyId) >= 0) {
				favoritesMarker.classList.add("isFavorite");
				propertyHolder.dataset.propertyIsSaved = "true";
			} else {
				favoritesMarker.classList.remove("isFavorite");
				delete propertyHolder.dataset.propertyIsSaved;
			}
		}

		const savedPropertiesCounts = document.querySelectorAll('.savedPropertiesCount');
		for (let i = 0; i < savedPropertiesCounts.length; i++) {
			let text = String(savedProperties.length);
			const savedPropertiesCount = savedPropertiesCounts.item(i);
			if ('true' === savedPropertiesCount.getAttribute('data-include-suffix')) {
				text += ' Saved ' + (savedProperties.length !== 1 ? 'Properties' : 'Property');
			}
			savedPropertiesCount.innerHTML = text;
		}
		
		const savedPropertiesInputs = document.querySelectorAll('input.savedPropertiesInput');
		const savedPropertiesRaw = this.getSavedPropertiesRaw();
		for (let i = 0; i < savedPropertiesInputs.length; i++) {
			(savedPropertiesInputs.item(i) as HTMLInputElement).value = savedPropertiesRaw;
		}

		const refreshMarkerIcons: () => void = (window as any).refreshMarkerIcons;
		if (typeof refreshMarkerIcons === 'function') {
			refreshMarkerIcons();
		}
	}
	
	private static getUrlParameter(name: string) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}
}

export default new SavedPropertiesManager();
